import { render, staticRenderFns } from "./IMPrice.vue?vue&type=template&id=b04235fe&"
import script from "./IMPrice.vue?vue&type=script&lang=js&"
export * from "./IMPrice.vue?vue&type=script&lang=js&"
import style0 from "./IMPrice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports